import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  PageEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as moment from "moment";

@Component({
  selector: "app-pl-sport-statment",
  templateUrl: "./pl-sport-statment.component.html",
  styleUrls: ["./pl-sport-statment.component.scss"],
})
export class PLSportStatmentComponent implements OnInit {
  selected: any = { startDate: 0, endDate: 0 };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  sportLevelList = new MatTableDataSource<any>();

  ProviderId = new FormControl([]);
  providers: any = [];
  sportId: string = "";
  sportLevelListDisplayedSportColumns: string[] = [
    "sport_name",
    "competition_name",
    "profit_loss",
  ];
  userId: string = "";
  userName: string = "";
  length: any = 0;
  OperatorId: string = "all";
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  origin = [];
  category = "";
  subProvider = "";
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  dropdownSettings: any = {};
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.providers = [ "Exchange","SportsBook"
      // { ProviderName: "Exchange", ProviderId: "Exchange" },
      // { ProviderName: "SportsBook", ProviderId: "SportsBook" },
    ];

    this.activatedRoute.queryParams.subscribe((params) => {
      this.OperatorId = params.operatorId;
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
      this.ProviderId.setValue([params.providerId]);
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.userId = params["userId"];
      this.userName = params["userName"];
      this.sportId = params["sportId"];
    });

    if (this.ProviderId.value[0]) {
      this.onSelectedProvider(this.ProviderId.value[0]);
    } else {
      this.onSelectedProvider("Exchange");
    }

    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // getOurProviders() {
  //   try {
  //     this.appService.getOurProviders().subscribe((res) => {
  //       if (res.status === "RS_OK") {
  //         this.providers = res.providers;
  //       } else {
  //         if (res.errorDescription === "Invalid Token!") {
  //           sessionStorage.clear();
  //           this.router.navigateByUrl("/login");
  //         }
  //       }
  //     });
  //   } catch (err) {}
  // }

  goToComponentCompetition(data): void {
    this.router.navigate(
      [`reports/pl-statment/${data.sportId}/${data.competitionId}`],
      {
        queryParams: {
          providerId: this.ProviderId.value[0],
          sportId: data.sportId,
          userId: this.userId ? this.userId : "",
          userName: this.userName ? this.userName : "",
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
        },
      }
    );
  }

  goBack = () => {
    this.router.navigate(["/reports/pl-statment"]);
  };

  onSelectedProvider = (pid) => {
    this.ProviderId.setValue([pid]);
    this.getReportData();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getReportData();
  }

  getReportData = () => {
    if (this.ProviderId.value[0] !== "all") {
      try {
        let filters = {
          sportId: String(this.sportId),
          providerId: this.ProviderId.value[0],
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
          userId: this.userId ? this.userId : null,
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          pageSize: this.orgPageSize,
          page: this.page,
        };

        this.appService.getSportPLData(filters).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.sportLevelList = new MatTableDataSource<any>(
              res.sportPnLReport
            );
            if (this.page == 1) {
              this.length = res.totalBets;
            } else {
              this.paginator.length = this.length;
            }
            // this.sportLevelList.paginator = this.paginator;
          }
        });
      } catch (err) {}
    }
  };
}
